// FILE: src/pages/About.jsx
import './About.css';

export default function About() {
  return (
    <div className="about-container">
      <h1>About Us</h1>
<p>
  <strong>Ocean Cruise Career Service</strong> is a leading maritime training and recruitment company dedicated to shaping future seafarers and hospitality professionals for global opportunities. Established with a vision to bridge the gap between passionate individuals and world-class marine careers, we provide a comprehensive platform for learning, development, and placement in the merchant navy, cruise liners, and offshore sectors.
</p>

<p>
  With a commitment to quality, safety, and international standards, we partner with reputed shipping companies, training institutes, and hospitality groups to offer specialized programs and employment pathways. Whether you're a fresher looking to start your maritime journey or a professional seeking career advancement, we ensure personalized support at every step.
</p>

<p>
  Our core services include:
</p>

<ul>
  <li>✅ Crew Manning & Deployment for Cargo, Cruise, Oil & Gas</li>
  <li>✅ STCW & DG-Approved Maritime Training Programs</li>
  <li>✅ Hotel and Hospitality Staff Recruitment for Ships & Resorts</li>
  <li>✅ Port Agency, Documentation, and Compliance Assistance</li>
  <li>✅ CDC/SID and VISA process and procedures</li>
</ul>

<p>
  Join us to embark on a global adventure with confidence, knowledge, and industry-backed expertise. At Ocean Cruise Career Service — we don't just prepare you for the sea, we prepare you for a lifelong maritime legacy.
</p>

    </div>
  );
}
